import { FC, ReactElement } from 'react'
import { isWeekend } from 'date-fns'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { LookingForHelpProps as Props } from './types'
import Image from 'next/image'
import styles from './LookingForHelp.module.scss'
import simulationStyles from '../../features/simulation/Simulation.module.scss'
import producersOverviewStyles from '../../features/producers-overview/ProducersOverview.module.scss'

const LookingForHelp: FC<Props> = ({ isHome, isProducersOverview, isSimulation, limitedHeight, showAvatar, positionAvatarLeft }) => {
  // i18n
  const { t } = useTranslation('lookingForHelp')

  /**
   * Returns the call section
   * @returns
   */
  const callSection = (): ReactElement => {
    const today = new Date()
    const available = isWeekend(today) === false

    return (
      <>
        <p className={classNames('margin-top-none', { 'margin-bottom-xs': limitedHeight }, { 'margin-bottom-s': !limitedHeight })}>
          {t('needHelp', 'Hulp nodig?')}&nbsp;
          <a
            href="tel:028993300"
            className={classNames(
              styles['phone-link'],
              { [producersOverviewStyles['phone-link']]: isProducersOverview },
              { [simulationStyles['phone-link']]: isSimulation }
            )}
          >
            {t('callNumber', 'Bel 02 899 33 00')}
          </a>
        </p>

        <p className="margin-bottom-none margin-top-none">
          {available ? t('available', 'We zijn vandaag bereikbaar tot 18:00') : t('unavailable', 'We zijn maandag bereikbaar vanaf 9:00')}
        </p>
      </>
    )
  }

  return (
    <div
      className={classNames(
        styles['looking-for-help'],
        { [styles['is-home']]: isHome },
        { [producersOverviewStyles['looking-for-help']]: isProducersOverview },
        { [simulationStyles['looking-for-help']]: isSimulation }
      )}
    >
      {showAvatar ? (
        <div className={classNames('is-flex-row is-flex-centered', { 'is-flex-row-reversed': positionAvatarLeft })}>
          <div
            className={classNames('is-fullwidth', {
              'margin-left-m': positionAvatarLeft,
              'margin-right-m': !positionAvatarLeft
            })}
          >
            {callSection()}
          </div>

          <div className={styles.avatar}>
            <Image src="/images/components/looking-for-help/fany.jpg" alt="Fany" className="is-block" width={100} height={100} />
          </div>
        </div>
      ) : (
        callSection()
      )}
    </div>
  )
}

LookingForHelp.defaultProps = {
  isHome: false,
  isProducersOverview: false,
  isSimulation: false,
  positionAvatarLeft: false
}

export default LookingForHelp
